import { Link } from 'react-router';
import styles from './campaign-banner.module.less';
import Avatar from '../components/avatar/Avatar';

export const CampaignBanner = ({ className, imageUrl, text, linkTo, linkText }) => {
    return (
        <div className={[styles.wrapper, className].join(' ')}>
            {imageUrl && <Avatar imageSrc={imageUrl} />}

            <p>
                {text} <Link to={linkTo}>{linkText}</Link>
            </p>
        </div>
    );
};
